import { FormInterface } from '../../../core/interfaces/form/Form';
import { FormInput, FormSelect } from '../../../component/input/InputStyle';
import FormLabel from '../../../component/input/FormLabel.component';
import { ChangeEvent, useEffect, useState } from 'react';
import { Store } from '../interfaces/Store';
import { getUserByName } from '../details/User.service';
import GridComponent from '../../../component/grid/GridComponent.component';
import { useFormik } from 'formik';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import { getAllRegion } from '../../scheduleMaintenance/regions/Region.service';
import { Region } from '../../scheduleMaintenance/regions/interfaces/Region';
import { getAllFormats } from '../../scheduleMaintenance/formats/Format.service';
import { Format } from '../../scheduleMaintenance/formats/interfaces/Format';
import { formatTelephone } from '../../../utils/format/FormatTelefone';
import { formatCepString } from '../../../utils/format/FormatCep';
import { formatIdStore } from '../../../utils/format/FormatIdStore';

import { formatHourString } from '../../../utils/format/FormatHour';
import { ListUF } from '../../../utils/constants/ufs';

interface IMenuItem {
  value: number;
  label: string;
}

export default function FormStoreCrud({
  handleSubmitForm,
  children,
  initialValues,
  disabled,
  setLoading,
  setCanSave,
  loading,
}: FormInterface<Store>) {
  const { handleSubmit, handleChange, values } = useFormik<Store>({
    initialValues: initialValues,
    onSubmit: (values) => {
      handleSubmitForm(values);
    },
  });

  const [regionList, setRegionList] = useState<IMenuItem[]>([]);
  const [formatList, setFormatList] = useState<IMenuItem[]>([]);

  const getListRegions = () => {
    try {
      getAllRegion({ flag_id: values.flag_id })
        .then((r) => {
          let itens = r.data;
          let lstItens: IMenuItem[] = [];

          itens.forEach((i: Region) => {
            i.id &&
              lstItens.push({
                value: i.id,
                label: i.description,
              });
          });

          setRegionList(lstItens);
          setCanSave && setCanSave(true);
          setLoading && setLoading(false);
        })
        .catch(() => {
          setCanSave && setCanSave(false);
          setLoading && setLoading(false);
        });
    } catch {
      setCanSave && setCanSave(false);
      setLoading && setLoading(false);
    }
  };

  const getListFormats = () => {
    try {
      getAllFormats()
        .then((r) => {
          let itens = r.data;
          let lstItens: IMenuItem[] = [];

          itens.forEach((i: Format) => {
            i.id &&
              lstItens.push({
                value: i.id,
                label: i.description,
              });
          });

          setFormatList(lstItens);
          setCanSave && setCanSave(true);
          setLoading && setLoading(false);
        })
        .catch(() => {
          setCanSave && setCanSave(false);
          setLoading && setLoading(false);
        });
    } catch {
      setCanSave && setCanSave(false);
      setLoading && setLoading(false);
    }
  };

  useEffect(() => {
    getListRegions();
    getListFormats();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
      <GridComponent justify='flex-start' alignItems='center' spacing={2}>
        <FormLabel title='ID Loja' sm={6} md={2} required>
          <FormInput
            name='id'
            value={values.id}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatIdStore(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 6 }}
            required
          />
        </FormLabel>

        <FormLabel title='Regional' sm={6} md={3} required>
          <FormSelect
            name='region_id'
            value={values.region_id}
            onChange={handleChange}
            disabled={disabled}
            required
          >
            {regionList.map((i: IMenuItem) => {
              return (
                <MenuItem key={i.value} value={i.value}>
                  {i.label.toUpperCase()}
                </MenuItem>
              );
            })}
          </FormSelect>
        </FormLabel>

        <FormLabel title='Formato' sm={6} md={3} required>
          <FormSelect
            name='format_id'
            value={values.format_id}
            onChange={handleChange}
            disabled={disabled}
            required
          >
            {formatList.map((i: IMenuItem) => {
              return (
                <MenuItem key={i.value} value={i.value}>
                  {i.label.toUpperCase()}
                </MenuItem>
              );
            })}
          </FormSelect>
        </FormLabel>

        <FormLabel title='Nome' sm={6} md={4} required>
          <FormInput
            name='Nome'
            value={values.Nome}
            onChange={handleChange}
            disabled={disabled}
            inputProps={{ maxLength: 40 }}
            required
          />
        </FormLabel>

        <FormLabel title='UF' sm={6} md={3}>
          <FormSelect name='UF' value={values.UF} onChange={handleChange} disabled={disabled}>
            {ListUF.map((i: { value: string; label: string }) => {
              return (
                <MenuItem key={i.value} value={i.value}>
                  {i.label}
                </MenuItem>
              );
            })}
          </FormSelect>
        </FormLabel>

        <FormLabel title='Cidade' sm={6} md={3}>
          <FormInput
            name='Cidade'
            value={values.Cidade}
            onChange={handleChange}
            disabled={disabled}
            inputProps={{ maxLength: 80 }}
          />
        </FormLabel>

        <FormLabel title='Bairro' sm={6} md={2}>
          <FormInput
            name='Bairro'
            value={values.Bairro}
            onChange={handleChange}
            disabled={disabled}
            inputProps={{ maxLength: 80 }}
          />
        </FormLabel>

        <FormLabel title='Logradouro' sm={6} md={4}>
          <FormInput
            name='Logradouro'
            value={values.Logradouro}
            onChange={handleChange}
            disabled={disabled}
            inputProps={{ maxLength: 255 }}
          />
        </FormLabel>

        <FormLabel title='Nº' sm={6} md={2}>
          <FormInput
            name='NumeroEstabelecimento'
            value={values.NumeroEstabelecimento}
            onChange={handleChange}
            disabled={disabled}
            inputProps={{ maxLength: 10 }}
          />
        </FormLabel>

        <FormLabel title='Complemento' sm={6} md={6}>
          <FormInput
            name='Complemento'
            value={values.Complemento}
            onChange={handleChange}
            disabled={disabled}
            inputProps={{ maxLength: 255 }}
          />
        </FormLabel>

        <FormLabel title='Cep' sm={6} md={2}>
          <FormInput
            name='Cep'
            value={values.Cep}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatCepString(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 9 }}
          />
        </FormLabel>

        <FormLabel title='Loja Fone' sm={6} md={2}>
          <FormInput
            name='Telefone'
            value={values.Telefone}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatTelephone(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 80 }}
          />
        </FormLabel>

        <FormLabel title='Exibir em Arcus' sm={6} md={2}>
          <FormSelect
            name='showInArcus'
            value={values.showInArcus}
            onChange={handleChange}
            disabled={disabled}
          >
            <MenuItem key={1} value={1}>
              Sim
            </MenuItem>
            <MenuItem key={0} value={0}>
              Não
            </MenuItem>
          </FormSelect>
        </FormLabel>

        <FormLabel title='Abertura Semana' sm={6} md={3}>
          <FormInput
            name='semanaInicio'
            value={values.semanaInicio}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatHourString(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 5 }}
            placeholder='00:00'
          />
        </FormLabel>

        <FormLabel title='Fechamento Semana' sm={6} md={3}>
          <FormInput
            name='semanaFim'
            value={values.semanaFim}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatHourString(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 5 }}
            placeholder='00:00'
          />
        </FormLabel>

        <FormLabel title='Abertura Sábado' sm={6} md={3}>
          <FormInput
            name='sabadoInicio'
            value={values.sabadoInicio}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatHourString(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 5 }}
            placeholder='00:00'
          />
        </FormLabel>

        <FormLabel title='Fechamento Sábado' sm={6} md={3}>
          <FormInput
            name='sabadoFim'
            value={values.sabadoFim}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatHourString(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 5 }}
            placeholder='00:00'
          />
        </FormLabel>

        <FormLabel title='Abertura Domingo' sm={6} md={3}>
          <FormInput
            name='domingoInicio'
            value={values.domingoInicio}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatHourString(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 5 }}
            placeholder='00:00'
          />
        </FormLabel>

        <FormLabel title='Fechamento Domingo' sm={6} md={3}>
          <FormInput
            name='domingoFim'
            value={values.domingoFim}
            onChange={(e: ChangeEvent<any>) => {
              e.target.value = formatHourString(e.target.value);
              handleChange(e);
            }}
            disabled={disabled}
            inputProps={{ maxLength: 5 }}
            placeholder='00:00'
          />
        </FormLabel>

        <Grid item xs={12}>
          {children}
        </Grid>
      </GridComponent>
    </form>
  );
}
